import { RiFacebookFill } from 'react-icons/ri';
import { AiOutlineTwitter } from 'react-icons/ai';
import { BsInstagram } from 'react-icons/bs';
import { FiPhoneCall } from 'react-icons/fi';
import { HiOutlineMail } from 'react-icons/hi';
import { MdLocationOn } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CONTACT_INFO } from '../../Helpers/Constant';

const Footer = () => {
  let year = new Date().getFullYear();
  return (
    <>
      <div className='meeta-footer-section meeta-footer-3'>
        <div className='footer-wrap'>
          <div className='container'>
            <div className='footer-widget-wrap'>
              <Row className='footer-main-row'>
                <Col xs={12} md={3} className='footer-col'>
                  <img
                    className='img-fluid footer-brand-logo'
                    src='/assets/logo2.png'
                    width={140}
                    alt='Asian Tourism Fair'
                  />
                </Col>

                <Col xs={12} md={3} className='footer-col'>
                  <div className='footer-widget'>
                    <h4 className='widget-title'>Explore</h4>
                    <div className='footer-menu'>
                      <ul>
                        <li>
                          <Link to='/'>About Us</Link>
                        </li>
                        <li>
                          <Link to='/'>Terms and Condition</Link>
                        </li>
                        <li>
                          <Link to='/'>Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to='/'>Refund Policy</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>

                <Col xs={12} md={4} className='footer-col'>
                  <div className='footer-widget'>
                    <h4 className='widget-title'>Contact Us</h4>
                    <div className='widget-info'>
                      <ul>
                        <li>
                          <div className='info-icon'>
                            <FiPhoneCall className='i' />
                          </div>
                          <div className='info-text'>
                            <span>
                              <Link to='/'>{CONTACT_INFO.phone}</Link>
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className='info-icon'>
                            <HiOutlineMail className='i' />
                          </div>
                          <div className='info-text'>
                            <span>{CONTACT_INFO.email}</span>
                          </div>
                        </li>
                        <li>
                          <div className='info-icon'>
                            <MdLocationOn className='i' />
                          </div>
                          <div className='info-text'>
                            <span>{CONTACT_INFO.address}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>

                <Col xs={12} md={2} className='footer-col'>
                  <div className='footer-widget'>
                    <h4 className='widget-title'>Social Media</h4>
                    <div className='widget-info'>
                      <div className='footer-widget-social'>
                        <a
                          href='https://www.facebook.com/asiantourismfair/'
                          target='_blank'
                        >
                          <RiFacebookFill />
                        </a>
                        <a href='https://x.com/ATFDhaka' target='_blank'>
                          <AiOutlineTwitter />
                        </a>
                        <a
                          href='https://www.instagram.com/asiantourismfair/'
                          target='_blank'
                        >
                          <BsInstagram />
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className='footer-copyright'>
            <div className='container'>
              <div className='row align-items-center footer-copyright-row'>
                <div className='col-lg-4 col-md-4'>
                  <div className='copyright-text'>
                    <p>{year} Copyright ATF. All Rights Reserved.</p>
                  </div>
                </div>
                <div className='col-lg-4 col-md-4'>
                  <img
                    className='img-fluid footer-payment-banner'
                    src='/assets/images/bitte/sslcommerz-banner.png'
                    alt=''
                  />
                </div>
                <div className='col-lg-4 col-md-4'>
                  <div className='copyright-text copyright-text-end'>
                    <p>
                      Technology Partner{' '}
                      <a
                        href='https://m360ict.com/'
                        target='_blank'
                        rel='noreferrer'
                      >
                        M360ICT
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
